module.exports = __webpack_public_path__ + "static/media/KPHI.ec249494.png";